<div class="bottom-container">
  <h1>Trusted</h1>
  <div class="logo-container">
    <img alt="logo 1" class="logo" src="logo22.png">
    <img alt="logo 2" class="logo" src="logo2.png">
    <img alt="logo 3" class="logo" src="logo3.png">
    <img alt="logo 4" class="logo" src="logo4.png">
    <img alt="logo 5" class="logo" src="logo5.png">
    <img alt="logo 6" class="logo" src="logo6.png">
    <img alt="logo 7" class="logo" src="logo7.png">
    <img alt="logo 8" class="logo" src="logo8.png">
    <img alt="logo 9" class="logo" src="logo9.png">
    <img alt="logo 10" class="logo" src="logo10.png">
    <img alt="logo 11" class="logo" src="logo11.png">
    <img alt="logo 12" class="logo" src="logo12.png">
    <img alt="logo 13" class="logo" src="logo13.png">
    <img alt="logo 14" class="logo" src="logo14.png">
    <img alt="logo 15" class="logo" src="logo15.png">
    <img alt="logo 16" class="logo" src="logo16.png">
    <img alt="logo 17" class="logo" src="logo17.png">
    <img alt="logo 18" class="logo" src="logo18.png">
    <img alt="logo 19" class="logo" src="logo19.png">
    <img alt="logo 20" class="logo" src="logo20.png">
    <img alt="logo 21" class="logo" src="logo21.png">
  </div>
</div>
